import type { EpiResourceRef } from '../types/epi-chat-types';

/**
 * Route an inline resource card opens. Once a concept-group draft's stable
 * catalog id is known the card goes straight to the canonical asset page
 * (OR-6288); every other card uses the route the event pushed.
 */
export const resourceCardRoute = (ref: EpiResourceRef): string => {
  const conceptGroupId =
    typeof ref.hintArgs?.conceptGroupId === 'string' ? ref.hintArgs.conceptGroupId : null;
  return conceptGroupId && ref.projectId
    ? `/projects/${ref.projectId}/concept-group/${conceptGroupId}`
    : ref.route;
};
